export class PaginationHelper {
    static getTotalPages(dataLength, elementsPerPage) {
        const totalPages = Math.floor(dataLength / elementsPerPage) + (0 === dataLength % elementsPerPage ? 0 : 1);
        return totalPages > 0 ? totalPages: 1;
    }
}
